<template>
  <div>
    <Modal title="计算资源配额" v-model="computeQuotaModal" width="800">
      <Alert show-icon type="error" v-if="computeQuotaError">{{ computeQuotaErrorMsg }}</Alert>
      <Spin fix v-if="computeQuotaLoading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
      <Spin fix v-else-if="computeQuotaGetError">
        <Alert show-icon type="error">获取数据失败</Alert>
      </Spin>
      <div v-else>
        <Alert show-icon>
          <span>填 -1 表示不限制</span>
        </Alert>
        <Form ref="computeQuotaForm" :model="computeQuotaForm" :rules="computeQuotaRules" :label-width="100">
          <FormItem prop="instances" label="实例">
            <InputNumber v-model="computeQuotaForm.instances" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="computeQuota.instances">
            <span style="color: #19be6b">已用：{{ computeQuota.instances.in_use }}</span>
          </span>
          </FormItem>
          <FormItem prop="cores" label="VCPU数量">
            <InputNumber v-model="computeQuotaForm.cores" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="computeQuota.cores">
            <span style="color: #19be6b">已用：{{ computeQuota.cores.in_use }}</span>
          </span>
          </FormItem>
          <FormItem prop="ram" label="内存(MB)">
            <InputNumber v-model="computeQuotaForm.ram" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="computeQuota.ram">
            <span style="color: #19be6b">已用：{{ computeQuota.ram.in_use }}</span>
          </span>
          </FormItem>
          <FormItem prop="key_pairs" label="密钥对">
            <InputNumber v-model="computeQuotaForm.key_pairs" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="computeQuota.key_pairs">
            <span style="color: #19be6b">已用：{{ computeQuota.key_pairs.in_use }}</span>
          </span>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="computeQuotaSubmit" :loading="computeQuotaSubmitting">修改</Button>
        <Button @click="computeQuotaModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudComputeQuota, updatePrivateCloudComputeQuota } from '@/api/private-cloud/quota-compute'

export default {
  name: 'compute-quota',
  data () {
    return {
      project: {},
      computeQuotaModal: false,
      computeQuotaSubmitting: false,
      computeQuotaLoading: false,
      computeQuotaGetError: false,
      computeQuotaError: false,
      computeQuotaErrorMsg: null,
      computeQuota: {},
      computeQuotaForm: {
        cores: null,
        instances: null,
        key_pairs: null,
        ram: null
      },
      computeQuotaRules: {
        cores: { required: true, message: 'VCPU数量是必填的', type: 'number', trigger: 'blur' },
        instances: { required: true, message: '实例数量是必填的', type: 'number', trigger: 'blur' },
        key_pairs: { required: true, message: '密钥对数量是必填的', type: 'number', trigger: 'blur' },
        ram: { required: true, message: '内存是必填的', type: 'number', trigger: 'blur' }
      }
    }
  },
  methods: {
    getComputeQuota (project) {
      this.project = project
      this.computeQuotaModal = true
      this.computeQuotaLoading = true
      getPrivateCloudComputeQuota(this.project.id).then(res => {
        this.computeQuotaLoading = false
        if (res.data.quota_set) {
          this.computeQuota = res.data.quota_set
          this.computeQuotaForm.cores = res.data.quota_set.cores.limit
          this.computeQuotaForm.instances = res.data.quota_set.instances.limit
          this.computeQuotaForm.key_pairs = res.data.quota_set.key_pairs.limit
          this.computeQuotaForm.ram = res.data.quota_set.ram.limit
          this.computeQuotaGetError = false
        } else {
          this.computeQuotaGetError = true
        }
      }).catch(res => {
        this.computeQuotaLoading = false
        this.computeQuotaGetError = true
        console.error(res.response)
      })
    },
    computeQuotaSubmit () {
      this.$refs.computeQuotaForm.validate((valid) => {
        if (valid) {
          this.computeQuotaSubmitting = true
          updatePrivateCloudComputeQuota(this.computeQuotaForm, this.project.id).then(res => {
            this.computeQuotaSubmitting = false
            this.computeQuotaModal = false
            this.computeQuotaError = false
            this.computeQuotaErrorMsg = null
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.computeQuotaSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.computeQuotaErrorMsg = res.response.data
            this.computeQuotaError = true
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
